import { createApp } from 'vue';
import cmpPromoOverview from '../vue/PromoOverview.vue';

window.PromoOverview = (function(){
	const component = createApp(cmpPromoOverview, {});
	return component.mount('#component-promo-overview');
})();